import { Component, OnChanges, Input } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { TextareaPrompt } from '../../../../../forms/models'
import { QuestionViewService } from '../..'

@Component({
  selector: 'mp-textarea-view',
  templateUrl: './textarea-view.html',
  styleUrls: ['./textarea-view.scss']
})
export class TextareaViewComponent implements OnChanges {
  @Input() public textareaPrompt: TextareaPrompt
  @Input() public formGroup: FormGroup

  public reviewMode: boolean = false

  public constructor(
    private _questionViewService: QuestionViewService
  ) {}

  public ngOnChanges() {
    this.reviewMode = this._questionViewService.reviewMode
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/text-views/textarea-view/textarea-view.component.ts